import { StrictMode, useCallback, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

interface Ripple {
  id: number;
  x: number;
  y: number;
  scale: number;
  opacity: number;
}

const InkdropApp = () => {
  const [ripples, setRipples] = useState<Ripple[]>([]);

  const createRipple = useCallback((e: MouseEvent) => {
    const ripple = {
      id: Date.now(),
      x: e.clientX,
      y: e.clientY,
      scale: 0,
      opacity: 1,
    };
    setRipples((prev) => [...prev, ripple]);
  }, []);

  useEffect(() => {
    window.addEventListener("mousedown", createRipple);
    return () => window.removeEventListener("mousedown", createRipple);
  }, [createRipple]);

  useEffect(() => {
    const interval = setInterval(() => {
      setRipples((prev) =>
        prev
          .map((r) => ({
            ...r,
            scale: r.scale + 0.05,
            opacity: r.opacity - 0.02,
          }))
          .filter((r) => r.opacity > 0),
      );
    }, 16);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        backgroundColor: "#f0f0f0",
        overflow: "hidden",
        cursor: "crosshair",
        margin: 0,
        padding: 0,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "20px",
          left: "20px",
          fontFamily: "sans-serif",
          color: "#333",
          pointerEvents: "none",
          zIndex: 10,
        }}
      >
        <h1 style={{ margin: 0 }}>Inkdrop</h1>
        <p style={{ margin: 0 }}>Click anywhere to drop ink</p>
      </div>
      {ripples.map((ripple) => (
        <div
          key={ripple.id}
          style={{
            position: "absolute",
            left: ripple.x,
            top: ripple.y,
            width: "100px",
            height: "100px",
            marginLeft: "-50px",
            marginTop: "-50px",
            borderRadius: "50%",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            transform: `scale(${ripple.scale})`,
            opacity: ripple.opacity,
            pointerEvents: "none",
          }}
        />
      ))}
    </div>
  );
};

const container = document.getElementById("root");
if (!container) {
  throw new Error("Missing #root element");
}

createRoot(container).render(
  <StrictMode>
    <InkdropApp />
  </StrictMode>,
);
